import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import Game from '../scenes/Game';
import UIAssetKeys from '../UIAssetKeys';

export default class PlusScore extends Phaser.GameObjects.Sprite {
  /**
   * 
   * @param {Game} scene 
   */
  constructor(scene) {
    super(scene,0,0,ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._plus10);

    this.scene = scene;
  }

  reset (x,y,spritename, doscale) {
    this.setFrame(spritename);
    this.alpha = 1;
    this.x = x;
    this.y = y;
    this.scale = 1;
    let toscale = 1;
    if (doscale) {
      toscale = 1.4;
    }
    this.scene.tweens.killTweensOf(this);
    ABCyaPhaser.Tweens.addTween(this, 620, { y: y - 100, scale: toscale }, Phaser.Math.Easing.Linear, () => this.fadeUp());
  }

  fadeUp () {
    this.scene.tweens.killTweensOf(this);
    ABCyaPhaser.Tweens.addTween(this, 120, { y: this.y - 20, alpha: 0 }, Phaser.Math.Easing.Linear, () => this.completeMe());
  }

  completeMe () {
    this.scene.resetFloatDisplay(this);
  }
}